import React from "react"
import ReactDOM from "react-dom/client"
import './styles/main.scss'
import './scripts/takeover-nav.js'

/// Components
import Recipe from './scripts/recipe';
import Product from './scripts/product';

import Segments from "./scripts/segments.js";
import ProductCatalog from './scripts/product_category';
import RecipeCatalog from './scripts/recipe_catalog';
import Search from './scripts/search';
import Chefs from './scripts/chefs';
import Map from './scripts/map';

if(document.querySelector('#render-react-segments') !== null){
  console.log("Running render-react-segments");
  const rootElement = document.querySelector("#render-react-segments");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Segments />);
}


if(document.querySelector('#render-react-recipe') !== null){
  console.log("Running render-react-Recipe");
  const rootElement = document.querySelector("#render-react-recipe");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Recipe postid={rootElement.dataset?.postid} />);
}

if(document.querySelector('#render-react-search') !== null){
  console.log("Running render-react-search");
  const rootElement = document.querySelector("#render-react-search");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Search />);
}

if(document.querySelector('#render-react-recipe-catalog') !== null){
  console.log("Running render-react-recipe-catalog");
  const rootElement = document.querySelector("#render-react-recipe-catalog");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RecipeCatalog />);
}

if(document.querySelector('#render-react-product_category') !== null){
  console.log("Running render-react-product_category");
  const rootElement = document.querySelector("#render-react-product_category");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<ProductCatalog />);
}

if (document.querySelector('#render-react-product') !== null) {
  console.log("Running render-react-product");
  const rootElement = document.querySelector("#render-react-product");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Product />);
}

if (document.querySelector('#render-react-chefs') !== null) {
  console.log("Running render-react-chefs");
  const rootElement = document.querySelector("#render-react-chefs");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Chefs />);
}
  


if (document.querySelector('#render-react-map') !== null) {
  console.log("Running render-react-map");
  const rootElement = document.querySelector("#render-react-map");
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Map />);
}

